import { sortingDateTimeFn } from "layouts/views/common/common";

export const pendingASNColumns = [
  {
    accessorKey: "orderNumber",
    header: "PO Number",
    align: "left",
  },
  {
    accessorKey: "customerCode",
    header: "Customer Code",
    align: "left",
  },
  {
    accessorKey: "orderDateStr",
    header: "PO Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "createdDateStr",
    header: "PO Created Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "orderQtyStr",
    header: "PO Qty",
    align: "right",
  },
];

export const pendingASNToReceiveColumns = [
  ...pendingASNColumns,
  {
    accessorKey: "asnNumber",
    header: "ASN Number",
    align: "left",
  },
  {
    accessorKey: "qtyExpectedStr",
    header: "ASN Qty",
    align: "right",
  },
  {
    accessorKey: "scanQtyStr",
    header: "Scan Qty",
    align: "right",
  },
  {
    accessorKey: "startScanStr",
    header: "Start Scan Date",
    align: "left",
  },
]

export const grnColumns = [
  ...pendingASNColumns,
  {
    accessorKey: "asnNumber",
    header: "ASN Number",
    align: "left",
  },
  {
    accessorKey: "startScanStr",
    header: "Start Scan Date",
    align: "left",
  },
  {
    accessorKey: "endScanStr",
    header: "End Scan Date",
    align: "left",
  },
  {
    accessorKey: "recvCode",
    header: "Recv Code",
    align: "left",
  },
  {
    accessorKey: "qtyExpectedStr",
    header: "ASN Qty",
    align: "right",
  },
  {
    accessorKey: "recvQtyStr",
    header: "Recv Qty",
    align: "right",
  },
  {
    accessorKey: "grnDateStr",
    header: "GRN Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const putawayGeneratedColumns = [
  ...grnColumns.filter(x => x.accessorKey !== "recvQtyStr" && x.accessorKey !== "qtyExpectedStr"),
  {
    accessorKey: "putawayNumber",
    header: "Putaway Number",
    align: "left",
  },
  {
    accessorKey: "qtyExpectedStr",
    header: "Qty Expected",
    align: "right",
  },
  {
    accessorKey: "putawayQtyStr",
    header: "Putaway Qty",
    align: "right",
  },
  {
    accessorKey: "putawayDateStr",
    header: "Putaway Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const completedColumns = [
  ...putawayGeneratedColumns,
  {
    accessorKey: "putawayCompleteDateStr",
    header: "Putaway Completed Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const coCancelledColumns = [
  {
    accessorKey: "orderNumber",
    header: "CO Number",
    align: "left",
  },
  {
    accessorKey: "customerCode",
    header: "Customer Code",
    align: "left",
  },
  {
    accessorKey: "orderDateStr",
    header: "CO Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "createdDateStr",
    header: "CO Created Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "orderQtyStr",
    header: "CO Qty",
    align: "right",
  },
]

export const pendingCOToReceiveColumns = [
  ...coCancelledColumns,
  {
    accessorKey: "scanQtyStr",
    header: "Scan Qty",
    align: "right",
  },
  {
    accessorKey: "startScanStr",
    header: "Start Scan Date",
    align: "left",
  },
]

export const coGRNColumns = [
  ...pendingCOToReceiveColumns.filter(x => x.accessorKey !== "scanQtyStr"),
  {
    accessorKey: "endScanStr",
    header: "End Scan Date",
    align: "left",
  },
  {
    accessorKey: "recvCode",
    header: "Recv Code",
    align: "left",
  },
  {
    accessorKey: "recvQtyStr",
    header: "Recv Qty",
    align: "right",
  },
  {
    accessorKey: "grnDateStr",
    header: "GRN Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const coPutawayGeneratedColumns = [
  ...coGRNColumns.filter(x => x.accessorKey !== "recvQtyStr"),
  {
    accessorKey: "putawayNumber",
    header: "Putaway Number",
    align: "left",
  },
  {
    accessorKey: "qtyExpectedStr",
    header: "Qty Expected",
    align: "right",
  },
  {
    accessorKey: "putawayQtyStr",
    header: "Putaway Qty",
    align: "right",
  },
  {
    accessorKey: "putawayDateStr",
    header: "Putaway Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const coCompletedColumns = [
  ...coPutawayGeneratedColumns,
  {
    accessorKey: "putawayCompleteDateStr",
    header: "Putaway Completed Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const miscCancelledColumns = [
  {
    accessorKey: "recvCode",
    header: "Recv Code",
    align: "left",
  },
  {
    accessorKey: "customerCode",
    header: "Customer Code",
    align: "left",
  },
  {
    accessorKey: "vDONo",
    header: "VDONo",
    align: "left",
  },
  {
    accessorKey: "grnDateStr",
    header: "Recv Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "orderDateStr",
    header: "Recv Created Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
  {
    accessorKey: "recvQtyStr",
    header: "Recv Qty",
    align: "right",
  },
]

export const miscGRNColumns = [
  ...miscCancelledColumns,
  {
    accessorKey: "startScanStr",
    header: "Start Scan Date",
    align: "left",
  },
  {
    accessorKey: "endScanStr",
    header: "End Scan Date",
    align: "left",
  },
]

export const miscPutawayGeneratedColumns = [
  ...miscGRNColumns,
  {
    accessorKey: "putawayNumber",
    header: "Putaway Number",
    align: "left",
  },
  {
    accessorKey: "putawayQtyStr",
    header: "Putaway Qty",
    align: "right",
  },
  {
    accessorKey: "putawayDateStr",
    header: "Putaway Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const miscCompletedColumns = [
  ...miscPutawayGeneratedColumns,
  {
    accessorKey: "putawayCompleteDateStr",
    header: "Putaway Completed Date",
    align: "left",
    sortingFn: sortingDateTimeFn,
  },
]

export const miscOpenColumns = [
  {
    accessorKey: "customerCode",
    header: "Customer Code",
    align: "left",
  },
  {
    accessorKey: "vDONo",
    header: "VDONo",
    align: "left",
  },
  {
    accessorKey: "recvQtyStr",
    header: "Recv Qty",
    align: "right",
  },
  {
    accessorKey: "startScanStr",
    header: "Start Scan Date",
    align: "left",
  },
]